module.exports = __webpack_public_path__ + "img/diamondjewelry.7ba6c38.jpg";